import React, { useState } from 'react';
import { Link } from 'gatsby';
import '../styles/navBarSite-styles.css';
import LogoMaroon from '../images/UChicago-logo-maroon.svg';
import LogoWhite from '../images/UChicago-logo-white.svg';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

//***************************************** SubSubNav = BRINGS IN THE 3rd LEVEL NAV *****************************************
const SubSubNav = ({ navNextLevel, basePath }) => {

    if (!navNextLevel || navNextLevel.length === 0) {
        return null;
    }
    return (
        <>
            <ul>
                {navNextLevel.map((subNav) => (
                    <Link
                        to={`${basePath}/${subNav.navSlug}`}
                    >
                        <li key={subNav.navItemName} >
                            {(subNav.showhideName) && (

                                <span className="second-level-links">{subNav.navItemName} </span>
                            

                            )}
                        </li>  </Link>
                ))}
            </ul>
        </>
    );
};

/* ************************************************************* LEFT LAYOUT VERSION  **************************************************************/
const LeftLayoutSubNav = ({ navNextLevel, basePath, navGroupName, navGroupImage, navGroupDescription }) => {

    if (!navNextLevel || navNextLevel.length === 0) {
        return null;
    }

    return (
        <>
            {navNextLevel && (

                <div className="sub-sub-nav">
                    <div className='triangle-up'></div>
                    <div className="nav-left">
                        <div><h5>{navGroupName}</h5></div>
                        <div className="image-container"><img src={navGroupImage} alt="Navigation Intro" loading="lazy"/> </div>
                        <div><p>{navGroupDescription}</p></div>
                    </div>
                    <div>
                        
                    {navNextLevel.map((navName, index) => (
                            <ul>
                            <li key={index} className="group-container">

                                <Link to={`${basePath}/${navName.navSlug}`}>
                                <ul>

                                    <li className="group-title"><h4>{navName.navItemName}</h4>
                                    {navGroupName !== ('Careers in...') ? (<p>{navName.navDescription}</p>) :
                                        null }</li>


                                </ul>
                                </Link> 


                            </li>
                            </ul>
                        ) )}
                        
                    </div>
                </div>
             )} 
        </>
    )

}

/* ************************************************************* GREY LAYOUT VERSION  **************************************************************/
const GreyLayoutSubNav = ({ navNextLevel, basePath, navGroupName, navGroupImage, navGroupDescription }) => {
    if (!navNextLevel || navNextLevel.length === 0) {
        return null;
    }
    return (
        <>
            <div className="sub-sub-nav">
                <div className='triangle-up'></div>
                {/* GREY TOP DESIGN - GREY BAR & INFO  */}
                {navNextLevel && (
                    <div className="nav-topper">
                        <div className='image-container'><img src={navGroupImage} alt="Navigation Intro" /> </div>
                        <div><h5>{navGroupName}</h5><p>{navGroupDescription}</p></div>
                    </div>
                )}
                <div>
                    <div className="col-left">
                        {navNextLevel.slice(0, 3).map((subNav) => (
                            <>
                                <ul>
                                    <li className="group-container">
                                        <ul><li className="group-title"><h4>{subNav.navItemName}</h4></li></ul>
                                        <SubSubNav navNextLevel={subNav.navNextLevel} basePath={`${basePath}/${subNav.navSlug}`} />
                                        
                                    </li>
                                </ul>
                            </>
                        ))}
                    </div>
                    <div className="col-right">
                        {navNextLevel.slice(3, 6).map((subNav) => (
                            <>
                                <ul>
                                    <li className="group-container">
                                        <ul><li className="group-title"><h4>{subNav.navItemName}</h4></li></ul>
                                        <SubSubNav navNextLevel={subNav.navNextLevel} basePath={`${basePath}/${subNav.navSlug}`} />
                                    </li>
                                </ul>
                            </>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};



const NavBarMainHome = ({ menuItems, interior }) => {
    const [hoveredNav] = useState(null);
    const [subNavItem, setSubNavItem] = useState(null);
    return (
        <Container fluid className={interior ? 'interior' : ''}>
            <Container>
                <Row><Col>
                    <nav>
                        <ul className="primary-nav">
                            <li>
                                <Link to="/">
                                    {(interior) ? <img src={LogoMaroon} alt="The University of Chicago Career Advancement" className="logo" /> : <img src={LogoWhite} alt="The University of Chicago Career Advancement" className="logo" />}
                                </Link>
                            </li>


                            <li>
                                {menuItems
                                    .filter(menuItem => menuItem.navLocation.includes('Main Navigation'))
                                    .sort((a, b) => a.navOrder - b.navOrder)
                                    .map((menuItem, index) => (
                                        <ul className="sub-nav" key={index}>
                                            <li>
                                                {/* /* *************************************** TOP VISIBLE LEVEL ONE NAV BAR LINK BELOW *************************************** */}

{/* *************************************** THE CLASSNAME MAKES THE LEVEL ONE LINK UNCLICKABLE - IF to={`/${menuItem.navSlug}`} is removed it will lose all subnav formatting ***************************************   */}
                                                <Link className="unclickable-link" to={`/${menuItem.navSlug}`} > {menuItem.navGroupName} </Link>
                                                <FontAwesomeIcon icon={faChevronDown} />
                                                {/* *************************************** HIDDEN LEVEL TWO NAV BAR INFO BELOW ***************************************  */}
                                                {menuItem.megaMenuLayout === "Left Hand Side Design" ? (
                                                    <LeftLayoutSubNav
                                                        
                                                        navNextLevel={menuItem.navNextLevel}
                                                        basePath={`/${menuItem.navSlug}`}
                                                        navGroupName={menuItem.navGroupName}
                                                        navGroupImage={menuItem.navImage.url}
                                                        navGroupDescription={menuItem.navDescription}
                                                    />
                                                ) :

                                                    menuItem.megaMenuLayout === 'Grey Top Design - MAX Entries' ? (
                                                        <GreyLayoutSubNav
                                                            navNextLevel={menuItem.navNextLevel}
                                                            basePath={`/${menuItem.navSlug}`}
                                                            navGroupName={menuItem.navGroupName}
                                                            navGroupImage={menuItem.navImage.url}
                                                            navGroupDescription={menuItem.navDescription}
                                                      
                                                        />
                                                    ) 
                                                    
                                                    :
                                                     null
                                                }
                                            </li>


                                            
                                        </ul>
                                    ))
                                }
                            </li>
                        </ul>
                    </nav>
                </Col></Row>
            </Container>
        </Container>
    );
};

export default NavBarMainHome;